module.exports = "/_next/static/images/21fe268851430e6f3c742969ec55dd5e-mulher-perfil-segurando-cartao-md@1x.jpg";